
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Default to production values
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || "https://ayordlzjnxgzjljjpdze.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImF5b3JkbHpqbnhnempsampwZHplIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDA0MjgyNzUsImV4cCI6MjA1NjAwNDI3NX0.ruKTjtBj2EJ-CjsWzlxT6A12dT0x6KkjHsqq0KDYqTM";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
